// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"443":"57244ff6","463":"d02350ae","715":"61413069","812":"0ed2d814"}[chunkId] + ".css";
};